module.exports = __webpack_public_path__ + "files/ac67f34005095552624526542aaae56f.png";